import { MEETINGS } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

export const meetingsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getMeetings: build.query({
      query: (params = {}) => ({ url: MEETINGS.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('Meeting', result),
    }),
    getMeetingById: build.query({
      query: (id) => ({ url: MEETINGS.BY_ID(id), method: 'GET' }),
      providesTags: (_r, _e, id) => [{ type: 'Meeting', id }],
    }),
    createMeeting: build.mutation({
      query: (body) => ({ url: MEETINGS.LIST, method: 'POST', data: body }),
      invalidatesTags: [{ type: 'Meeting', id: 'LIST' }],
    }),
    updateMeeting: build.mutation({
      query: ({ id, ...body }) => ({
        url: MEETINGS.BY_ID(id),
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Meeting', id },
        { type: 'Meeting', id: 'LIST' },
      ],
    }),
    updateMeetingStatus: build.mutation({
      query: ({ id, ...body }) => ({
        url: MEETINGS.UPDATE_STATUS(id),
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Meeting', id },
        { type: 'Meeting', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetMeetingsQuery,
  useLazyGetMeetingsQuery,
  useGetMeetingByIdQuery,
  useLazyGetMeetingByIdQuery,
  useCreateMeetingMutation,
  useUpdateMeetingMutation,
  useUpdateMeetingStatusMutation,
} = meetingsApi;
